export default "__VITE_ASSET__wWnJLeVJ__"